<template>
  <!-- 导航开始 -->
  <div class='commonHomeMemostore' :class="{appBool:appBool}">
    <div class="scrollBox">
      <div class="traceStoreBox" v-if="!isShow">
        <h2 class="mb-0">
          修改忘录
        </h2>
        <div class="mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">执行</span>
              </div>
              <input type="text" v-model="timesVal" ref="timesNode" onclick="WdatePicker({isShowClear:false,readOnly:true,dateFmt:'yyyy-MM-dd HH:mm'})" class="form-control" readonly="">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">标题</span>
              </div>
              <input type="text" v-model="titleVal" class="form-control">
            </div>
          </div>
        </div>
        <div class="mb-3">
          <div class="box">
            <div class="input-group">
              <div class="input-group-prepend">
                <span class="input-group-text">备注</span>
              </div>
              <textarea class="form-control" v-model="contentsVal" rows="5"></textarea>
            </div>
          </div>
        </div>
        <div class="anniuBox towBox">
          <div class="box" style="flex: 3;">
            <span @click="modifyFun" type="button" class="btn btn-success btn-round btn-block">
              <i v-if="isLoading" class='iconfont icon-jiazai xuanzhuan'></i>
              修改
            </span>
          </div>
          <div>
            <span @click="delFun" type="button" class="btn btn-danger btn-round btn-block">
            <i v-if="isDelLoading" class='iconfont icon-jiazai xuanzhuan'></i>
            删除
          </span>
          </div>
        </div>
      </div>
      <div v-else class="traceStoreBox">
        <dl class="row">
          <dd class="col-sm-12"><h3>{{info.title}}</h3>
            <br>
            <p class="content">— 备忘录</p>
            <hr>
          </dd>
          <dt class="col-sm-3">时间</dt>
          <dd class="col-sm-9">{{info.timesVal}}</dd>
          <dt class="col-sm-3">备注</dt>
          <dd class="col-sm-9">{{info.contents}}</dd>
          <dt class="col-sm-3"></dt>
          <dd class="col-sm-9" v-if="!appBool">
            <br>
            <span @click="isShow=false" type="button" class="btn btn-secondary">
              修改
            </span>
          </dd>
        </dl>
      </div>
    </div>
  </div>
  <!-- 导航结束 -->
</template>

<script>
import resultCommons from '@/util/resultcommons';
import { EventBus } from '@/util/eventBus';
import { apiUsernoticeinfo } from '../../../request/api'; // 引入事件总线

export default {
  name: 'commonHomeMemostore',
  props: {
    token: {
      type: String,
      default: '',
    },
    appBool: {
      type: Boolean,
      default: false,
    },
    isSuccessFun: {
      type: Function,
      default() {
        return Function;
      },
    },
  },
  data() {
    return {
      // 提交中
      isLoading: false,
      // 删除中
      isDelLoading: false,
      // 跟进类型
      titleVal: '',
      contentsVal: '',
      timesVal: '',
      info: {},

      isShow: true,
    };
  },
  computed: {
  },
  methods: {
    modifyFun() {
      // 遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 加载中
      this.isLoading = true;
      // 可以执行登录
      resultCommons.apiMemomodify(this, {
        title: this.titleVal,
        times: this.$refs.timesNode.value,
        contents: this.contentsVal,
        token: this.token,
      }).then((ob) => {
        // 取消加载
        this.isLoading = false;
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 遮罩
        if (ob.state === 200) {
          this.isSuccessFun(3, ob.data);
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
    delFun() {
      // 全局遮罩
      EventBus.$emit('globalZhezhaoBoxFun', true);
      // 删除中
      this.isDelLoading = true;
      // 执行删除
      resultCommons.apiMemodel(this, { token: this.token }).then((ob) => {
        // 遮罩
        EventBus.$emit('globalZhezhaoBoxFun', false);
        // 删除中
        this.isDelLoading = false;
        if (ob.state === 200) {
          this.isSuccessFun(2, { token: this.token, type: this.typeVal });
          this.$message.showMsgBox({ type: 'success', content: ob.message });
        } else {
          this.$message.showMsgBox({ type: 'warning', content: ob.message });
        }
      });
    },
  },
  components: {
  },
  created() {
    resultCommons.apiMemoinfo(this, { token: this.token }).then((ob) => {
      if (ob.state === 200) {
        const info = ob.data;
        this.timesVal = info.timesVal;
        this.titleVal = info.title;
        this.contentsVal = info.contents;
        this.info = info;
      } else {
        this.$message.showMsgBox({ type: 'warning', content: ob.message });
      }
    });
  },
  mounted() {
  },
  destroyed() {
  },
};
</script>

<style scoped lang='less'>
.commonHomeMemostore{
  box-shadow: 0 0 1rem rgba(0, 0, 0, .3);
  background: #FFFFFF;
  width: 480px;
  display: flex;
  flex-direction: column;
  padding-bottom: 0;
  overflow: hidden;
  display: flex;
  justify-content: center;
  &.appBool{
    height: 100%;
    margin: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }
  div.scrollBox{
    padding: 30px 50px;
    overflow-y: auto;
    h2{
      padding-bottom: 30px;
      font-family: 'gilroy-semibold';
    }
    .towBox{
      display: flex;
      div.box{
        flex: 1;
        &:first-child{
          margin-right: 15px;
        }
      }
    }
    .anniuBox{
      span{
        height: 35px;
        i.iconfont{
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/home/memomodify.vue